var _defs, _rect, _rect2, _rect3, _rect4, _circle, _circle2, _line, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSatsatLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 580",
    width: 500,
    height: 580,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      @import url('https://fonts.googleapis.com/css2?family=Lora:ital,wght@1,600&amp;display=swap');\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 580,
    fill: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 130,
    width: 16,
    height: 310,
    rx: 4,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 130,
    width: 16,
    height: 310,
    rx: 4,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 130,
    width: 14,
    height: 310,
    rx: 4,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 285,
    r: 155,
    fill: "white",
    stroke: "black",
    strokeWidth: 15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 285,
    r: 115,
    fill: "white",
    stroke: "black",
    strokeWidth: 8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 471,
    x2: 500,
    y2: 471,
    stroke: "black",
    strokeWidth: 3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 550,
    textAnchor: "middle",
    fontFamily: "'Lora', Georgia, serif",
    fontSize: 72,
    fontWeight: 600,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#315532"
  }, "Sat"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#AACEAB"
  }, "Sat"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatsatLogo);
export default __webpack_public_path__ + "static/media/satsat-logo.ad87b380b881fde205b150eaa1f4bd31.svg";
export { ForwardRef as ReactComponent };